import { Layout } from "antd";
import { ToggleableProps } from "../common/Toggleable";
import { Content } from "antd/es/layout/layout";
import { Page } from "../common/Page";
import { Modal } from "../common/Modal";

export const UserPageLayout = function (props: {
    list: any,
    detailForm: any,
    toggle?: ToggleableProps
}) {

    return (
        <Page name="Users">
            <Layout style={{ height: "100%" }} >
                <Content style={{overflowY: "auto" }}>
                    {props.list}
                </Content>
            </Layout>

            <Modal title="Editando usuario" mode="FullPage"
                toggle={props.toggle} onCancel={props.toggle?.hide}
            >
                {props.detailForm}
            </Modal>
        </Page>
    );
}
